// Site-wide safety net for resized images (/api/img). If a variant fails —
// e.g. the frontend was deployed before the backend was restarted, so the
// endpoint doesn't exist yet — show the original upload instead of a broken
// image. This matters most for images inside article HTML, which have no
// onError of their own.
//
// Images with their own onError (cards, heroes — see imgErrorFallback in
// img.js) handle it themselves: this runs after them and skips any image they
// already took care of (data-tried-original).
import { originalUrl } from "./img";

const VARIANT_RE = /\/api\/img\?/;

function onImgError(e) {
  const img = e.target;
  if (!(img instanceof HTMLImageElement)) return;
  const url = img.currentSrc || img.getAttribute("src") || "";
  if (!VARIANT_RE.test(url)) return;
  // Let the image's own onError (if any) run first.
  setTimeout(() => {
    if (img.dataset.triedOriginal) return;
    let src = null;
    try {
      src = new URL(url, window.location.href).searchParams.get("src");
    } catch {
      return;
    }
    if (!src || !src.startsWith("/uploads/")) return;
    img.dataset.triedOriginal = "1";
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
    img.src = originalUrl(src);
  }, 0);
}

// Error events don't bubble, so listen in the capture phase.
if (typeof window !== "undefined") window.addEventListener("error", onImgError, true);
